import React from 'react';
import styled from 'styled-components';

function Title({children, options, ...props}) {
  return (
    <CardTitleContainer {...props}>
      <H4>{children}</H4>
      {options && (
        <Options>
          {options}
        </Options>
      )}
    </CardTitleContainer>
  );
}

const CardTitleContainer = styled.div`
  display: flex;
  align-items: center;
`;

const H4 = styled.h4`
  margin: 0;
  padding: 0;
  font-size: 1.125rem;
  font-weight: 500;
  padding: 1.25rem 1.875rem;
  flex: 1;
`;

const Options = styled.div`
  padding: 0 1.875rem;
`;

export default Title;